import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "seller-settings" }
const _hoisted_2 = { class: "form-group stage-b-item" }
const _hoisted_3 = {
  for: "break-start",
  class: "form-label"
}
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = {
  for: "once-twice-sold",
  class: "form-label"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = {
  for: "break-pinned-message",
  class: "form-label"
}
const _hoisted_8 = { class: "action-block" }

import { trans } from "@/utils/trans";

export default /*#__PURE__*/_defineComponent({
  __name: 'Break',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_unref(trans)("live.tabs.settings_network.break_tab.labels.break_start_time")), 1),
      _cache[1] || (_cache[1] = _createElementVNode("select", {
        id: "break-start",
        class: "form-select-field"
      }, [
        _createElementVNode("option", { value: 0 }, _toDisplayString("10 : 30 AM EDT")),
        _createElementVNode("option", { value: 1 }, _toDisplayString("10 : 40 AM EDT"))
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(trans)("live.tabs.settings_network.break_tab.labels.break_finish_time")), 1),
      _cache[2] || (_cache[2] = _createElementVNode("select", {
        id: "once-twice-sold",
        class: "form-select-field"
      }, [
        _createElementVNode("option", { value: 0 }, _toDisplayString("11 : 00 AM EDT")),
        _createElementVNode("option", { value: 1 }, _toDisplayString("11 : 30 AM EDT"))
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(trans)("live.tabs.settings_network.break_tab.labels.pinned_message")), 1),
      _cache[3] || (_cache[3] = _createElementVNode("textarea", {
        id: "break-pinned-message",
        class: "form-textarea-field textarea"
      }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        class: "btn btn-blue action",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
      }, _toDisplayString(_unref(trans)("live.tabs.settings_network.break_tab.actions.save")), 1)
    ])
  ]))
}
}

})